import { Routes } from '@angular/router';

import { authGuard } from './core/auth.guard';
import { accessGuard, adminGuard } from './core/access.guard';
import { RequisitionDashboardComponent } from './features/dashboard/requisition-dashboard.component';
import { FinancialManagementComponent } from './features/financial-management/financial-management.component';
import { LifecycleComponent } from './features/lifecycle/lifecycle.component';
import { LoginComponent } from './features/login/login.component';
import { ProfileComponent } from './features/profile/profile.component';
import { ReportsComponent } from './features/reports/reports.component';
import { ThemeComponent } from './features/theme/theme.component';
import { UsersComponent } from './features/users/users.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: '', component: RequisitionDashboardComponent, canActivate: [authGuard, accessGuard], data: { functionality: 'dashboard' } },
  { path: 'lifecycle/:stage', component: LifecycleComponent, canActivate: [authGuard, accessGuard] },
  { path: 'financial-management', component: FinancialManagementComponent, canActivate: [authGuard, accessGuard], data: { functionality: 'financial_management' } },
  { path: 'reports', component: ReportsComponent, canActivate: [authGuard, accessGuard], data: { functionality: 'reports' } },
  { path: 'theme', component: ThemeComponent, canActivate: [authGuard] },
  { path: 'profile', component: ProfileComponent, canActivate: [authGuard] },
  { path: 'users', component: UsersComponent, canActivate: [authGuard, adminGuard] },
  { path: '**', redirectTo: '' }
];
